import React from "react";
import RadioButton from "../formikComponents/inputradio";
import QuizInput from  "../formikComponents/fillinput";

function FormikControl(props){
    const {control,...rest} =props
    if(control.length >1)
    switch (control){
        case "multiple_choice":
            return <RadioButton {...rest} />
        case 'true_or_false':
            return <RadioButton {...rest} />
        case 'fill_in_the_blanks':
            return <QuizInput {...rest} />
        default :
            return false
    }

}
export default FormikControl;
